module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/url-mapper/~/isarray/index.js
// module id = 288
// module chunks = 0